module.exports = [
    {
        label: 'DEFAULT',
        style: 'default',
        color: '#333333'
    },
    {
        label: 'RED',
        style: 'red',
        color: '#FF0000'
    },
    {
        label: 'ORANGE',
        style: 'orange',
        color: '#FD7222'
    },
    {
        label: 'YELLOW',
        style: 'yellow',
        color: '#FEEE35'
    },
    {
        label: 'GREEN',
        style: 'green',
        color: '#3AA03A'
    },
    {
        label: 'BLUE',
        style: 'blue',
        color: '#2A82D7'
    }
];



// WEBPACK FOOTER //
// ./src/colors/colors.js